import React from 'react';
import colors from '@general/colors';
import ArrowRightIcon from '@icons/ArrowRightIcon';
import EditIcon from '@icons/EditIcon';
import TrashIcon from '@icons/TrashIcon';
import CardChip from '@molecules/CardChip';
import { BodySmall, ButtonNoStyles, H4, LinkRouter } from '@react/styledComponents';
import { Link, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { getSavedSearchTitle } from '../../../../helpers/savedSearches.helpers';
import HeadshotArray from '../../../_molecules/HeadshotArray';
import { SavedSearchDescription } from './CreateMatchesForm/description';
import { NEW_CONNECTIONS_MAX_DAYS } from '../../../../hooks/useSavedSearchesWithMatches';

const MatchCriteriaContainer = styled.div`
    align-items: flex-start;
    border-top: 1px solid ${colors.lightGray};
    display: flex;
    gap: 1rem;
    justify-content: space-between;
    padding-top: 2rem;
    padding-bottom: 1.5rem;
`;

const styles = {
    borderTop: {},
};

const ConnectionCountMessage = ({ matchesCount }) => {
    if (matchesCount === 0) return null;
    const msg = `${matchesCount} new ${
        matchesCount === 1 ? 'connection' : 'connections'
    } in the past ${NEW_CONNECTIONS_MAX_DAYS} days`;
    return <BodySmall>{msg}</BodySmall>;
};

export default function Match(props) {
    const { savedSearch, handleClickSavedSearch, deleteSavedSearch, matches = [], newMatchesOnly } = props;

    if (newMatchesOnly && matches.length === 0) return null;

    return (
        <MatchCriteriaContainer style={styles.borderTop} key={savedSearch.id}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', just: 'flex-start' }}>
                <div>
                    <Link
                        className="hover:text-color-link"
                        to={`/my-icsc/connections/matches/${savedSearch.id}`}
                        onClick={() => {
                            handleClickSavedSearch(savedSearch);
                        }}
                    >
                        <H4>
                            {getSavedSearchTitle(savedSearch)}
                            {matches.length > 0 ? (
                                <CardChip style={{ marginTop: -5, marginLeft: '0.5rem' }}>New Connections</CardChip>
                            ) : null}
                        </H4>
                    </Link>
                </div>

                <BodySmall>
                    <SavedSearchDescription values={savedSearch} />
                </BodySmall>

                <HeadshotArray hits={matches} numToShow={7} />

                <ConnectionCountMessage matchesCount={matches.length} />

                <LinkRouter
                    className="hover:arrow-right-icon-move"
                    to={`/my-icsc/connections/matches/${savedSearch.id}`}
                    onClick={() => {
                        handleClickSavedSearch(savedSearch);
                    }}
                >
                    See Your Matches <ArrowRightIcon color={colors.link} />
                </LinkRouter>
            </div>

            <div className="d-flex">
                <Link title="Edit match criteria" to={`/my-icsc/connections/matches/${savedSearch.id}/edit`}>
                    <EditIcon />
                </Link>

                <ButtonNoStyles
                    className="cursor-pointer deletecriteria"
                    title="Remove match criteria"
                    onClick={() => deleteSavedSearch(savedSearch.id)}
                >
                    <TrashIcon />
                </ButtonNoStyles>
            </div>
        </MatchCriteriaContainer>
    );
}
